import { tableCellConfig } from '../config/tableCellConfig';
import { getColumnKey } from '../utils/utils';

export const useTableCellRenderer = ({
	mode,
	viewMode,
	onChange,
	options,
}) => {
	return (rowData, rowIndex, header) => {
		const columnKey = getColumnKey(header, mode);
		const config = tableCellConfig?.[mode]?.[columnKey];
		if (!config?.render) return null;

		const cellData = rowData[header.id] || {};
		return config.render({
			value: cellData?.qty,
			unit: cellData?.unit,
			noOrder: cellData?.noOrder,
			options,
			viewMode,
			onChange: (value) => onChange(value, cellData, rowData, header),
			rowData,
			rowIndex,
			header,
		});
	};
};
